export const aciArrowDown = {
    iconName: 'arrow-down',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: {
            attr: {
                'fill-rule': 'evenodd',
                'clip-rule': 'evenodd',
                d: 'M2.394 6.884c-.306.074-.482.447-.35.743.06.13 9.132 9.207 9.332 9.334.202.13.338.165.624.165.287 0 .422-.036.625-.165.2-.127 9.272-9.203 9.33-9.334a.564.564 0 00-.012-.466.54.54 0 00-.718-.234c-.024.013-2.098 2.076-4.608 4.585-3.626 3.623-4.575 4.56-4.617 4.56-.042 0-.99-.937-4.616-4.562-3.097-3.096-4.588-4.573-4.639-4.593a.637.637 0 00-.35-.033z',
                fill: 'currentColor',
            },
        },
    },
};
